export function Close() {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 14 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.364 2.33309C13.8326 1.86447 13.8326 1.10467 13.364 0.636039C12.8953 0.16741 12.1355 0.16741 11.6669 0.636039L6.99999 5.30294L2.33309 0.636039C1.86446 0.16741 1.10466 0.16741 0.636033 0.636039C0.167404 1.10467 0.167404 1.86447 0.636033 2.3331L5.30294 7L0.636033 11.6669C0.167404 12.1355 0.167404 12.8953 0.636033 13.364C1.10466 13.8326 1.86446 13.8326 2.33309 13.364L6.99999 8.69706L11.6669 13.364C12.1355 13.8326 12.8953 13.8326 13.364 13.364C13.8326 12.8953 13.8326 12.1355 13.364 11.6669L8.69705 7L13.364 2.33309Z"
        fill="currentColor"
      />
    </svg>
  );
}
